import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import IsSubmitting from "./IsSubmitting";

const axios = require("axios");

class PlayerInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerName: "",
      playerLevel: this.props.level,
      playerScore: this.props.score,
      highscoreCrypto: this.props.highscoreCrypto,
      toTable: false,
      isSubmitting: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loading = this.loading.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  loading() {
    this.setState({
      isSubmitting: true,
    });
  }

  handleSubmit(event) {
    this.loading();
    event.preventDefault();
    const apiUrl = process.env.REACT_APP_API_URL;

    axios
      .post(`${apiUrl}/highscores`, {
        name: this.state.playerName,
        level: this.state.playerLevel,
        score: this.state.playerScore,
        secret: this.state.highscoreCrypto,
      })
      .then(() => {
        this.setState({
          toTable: true,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
    // .then(res => {
    //   console.log(res);
    // })
    // .then(err => {
    //   if (err) {
    //     throw err;
    //   }
    // })
    // .then(() => {
    //   this.setState({
    //     toTable: true
    //   });
    // });
  }

  render() {
    if (this.state.toTable === true) {
      return <Redirect exact to="/spaceblocks/scores" />;
    }
    return (
      <div className="player-form">
        <h1>You scored {this.state.playerScore} points!</h1>
        <h2>Please type your alias and submit to log your score!</h2>
        <form onSubmit={this.handleSubmit}>
          <input
            className="input-field"
            type="text"
            name="playerName"
            value={this.state.playerName}
            onChange={this.handleChange}
            placeholder="Please enter your name"
          />
          <button className="submit-button">Submit</button>
        </form>
        <Link to="/spaceblocks">
          <button>Back</button>
        </Link>
        <IsSubmitting submitting={this.state.isSubmitting} />
      </div>
    );
  }
}

export default PlayerInput;
